<template>
  <div class="footer-bar">
    <div class="grid-container flex space-between align-items-center border-box">
      <span>Copyright &copy; 2020</span>
      <div class="image-container">
        <img class="image-fit" :src="BlocodeLogoWhite"/>
      </div>
      <span>Designed by Dichi</span>
    </div>
  </div>
</template>

<script>
  import BlocodeLogoWhite from '@/assets/BlocodeLogoWhite.png'

  export default {
    name: 'footerBar',
    data() {
      return {
        BlocodeLogoWhite
      }
    },
    computed: {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";

  .footer-bar {
    margin-top: 3rem;
    padding: 1rem;
    background-color: $dark-gray;
    color: white;
    font-size: 0.8rem;
  }

  .image-container {
    height: 2rem;
    opacity: 0.3;
  }
</style>
